import { render, staticRenderFns } from "./YouTubeButton.vue?vue&type=template&id=45fbae6b&scoped=true&"
import script from "./YouTubeButton.vue?vue&type=script&lang=js&"
export * from "./YouTubeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fbae6b",
  null
  
)

export default component.exports